<!-- exact copy of Dropdown2 - in use in ManulRegistration.vue and CandidatePaymentContract.vue-->
<template>
	<v-autocomplete
		:error="errorBorder"
		:error-messages="$props.error"
		:items="options"
		:label="label"
		:readonly="readonly"
		:disabled="disabled"
		:clearable="clearable && !readonly"
		:hide-details="hideDetails"
		item-text="label"
		item-value="value"
		:no-data-text="$t('labels.noData')"
		v-model="selectedValue"
		@change="handleSelection"
	>
		<template #prepend-item>
			<slot name="firstItem"></slot>
		</template>
		<template #prepend>
			<slot name="prepend"></slot>
		</template>
	</v-autocomplete>
</template>

<script>
export default {
	name: 'Dropdown2_copy',
	props: {
		readonly: Boolean,
		disabled: Boolean,
		clearable: Boolean,
		value: [String, Number, Boolean],
		ajax: Boolean,
		data: [Array, String],
		label: String,
		errorBorder: {
			type: Boolean,
			default: false,
		},
		error: {
			type: String,
			default: '',
		},
	},
	emits: ['item-selected'],
	data() {
		return {
			endpoint: '',
			selectedValue: null,
			options: [],
			ajaxLoaded: false,
			protected: null,
			latestValue: null,
			selectedLabel: null,
		};
	},
	computed: {
		hideDetails() {
			return this.$props.error === '';
		},
	},
	watch: {
		value: function (newVal, oldVal) {
			if (newVal != oldVal) {
				if (newVal != this.selectedValue) {
					this.protected = newVal;
					this.setValue(newVal);
				}
			}
		},
		selectedValue: function (val) {
			if (val != this.$props.value) {
				if (val != null) {
					if (val != this.$props.value) {
						this.$nextTick(() => {
							this.$emit('input', val);
						});
					}
				} else {
					this.$nextTick(() => {
						this.$emit('input', null);
					});
				}
				this.$nextTick(() => {
					this.callChange();
				});
			}
		},
	},
	methods: {
		callChange() {
			this.$emit('changes');
		},
		setValue(newVal) {
			this.latestValue = newVal;
			if (this.$props.ajax) {
				var vm = this;
				this.$APICall(
					'get',
					'select/' + this.endpoint,
					{ protected: this.protected },
					(data, success) => {
						if (success && vm.latestValue == newVal) {
							vm.options = data;
							vm.ajaxLoaded = true;
							vm.selectedValue = newVal;
						}
					},
					false
				);
			} else {
				this.options = this.$props.data;
				this.selectedValue = newVal;
			}
		},
		handleSelection() {
			const selectedItem = this.options.find((item) => item.value === this.selectedValue);
			if (selectedItem) {
				this.$emit('item-selected', {
					id: this.selectedValue,
					name: selectedItem.label,
				});
			}
			this.callChange();
		},
	},
	mounted() {
		if (this.$props.ajax) {
			this.endpoint = this.$props.data;
		}
		this.protected = this.$props.value;
		this.setValue(this.$props.value);
	},
};
</script>

<style scoped>
.v-select-list {
	max-width: 1100px;
}
</style>
